// extracted by mini-css-extract-plugin
module.exports = {"list":"browse-BrowseListGrid__list--2LRWK"};